import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, Grid, Modal, SvgIcon, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { CSSProperties, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import loader from 'src/components/LoaderImg/loader.gif';
import {
  baseApiUrl,
  goalBankTreatment,
  prefillIdCPTICDTreatment,
  reFormsPtEvalTreatment,
  reFormsSlpEvalTreatment,
} from 'src/config';
import useCurrentUser from 'src/hooks/use-current-user';
import useFeatureToggle, { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { paths } from 'src/paths';
import {
  checkIsReformAction,
  errorForLoaderDocumentation,
  pullUuidAction,
  requestForLoaderDocumentation,
  resetForLoaderDocumentation,
  resetUuidAction,
  successForLoaderDocumentation,
} from 'src/redux/actions/documentationAction';
import { getAccessToken } from 'src/routes/AuthContext';
import { subscribeSubmissionevent } from 'src/services/apiServices/constants';
import { checkSupervisorPermission } from 'src/utils/checkSignatureAccess';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import PageLeaveConfirmModal from '../common-modals/page-leave-confirmation';
import ReForm from '../reform';
import SucessModal from '../sucess-modal';
import CopyGoalWidget from './copy-goal-widget';

const loaderCSS: CSSProperties = {
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitUserSelect: 'none',
  KhtmlUserSelect: 'none',
  MozUserSelect: 'none',
  userSelect: 'none',
  zIndex: 9999,
};

function EditDocumentPreview() {
  // const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { patients, patientDetails, episodeOfCare, details } = paths;
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const { document, episodeOfCareId, patientData, activeTab } = useSelector(
    (state: any) => state.eocEditDocumentDataReducer
  );
  const [providerId] = useCurrentUser(['providerId']);
  const submissionSse = useRef<EventSource | null>(null);
  const getSignatureAccess = useSelector((state: any) => state.getSignatureAccessReducer);
  const pullUuidResponse = useSelector((state: any) => state.pullUuidRducder);
  const isDocLoader = useSelector((state: any) => state.loaderDocumenattionReducer);
  const episodeOfCareData = useSelector((state: any) => state?.getSingleEpisodeOfCare?.response);
  const getStartOfCareDate = useSelector((state: any) => state.getStartOfCareDateReducer?.response);
  const [checkGoalBankToggle] = useFeatureToggle(goalBankTreatment, 'FACILITY');
  const [getPrefillKey, setPrefillKey] = useState<string>('');
  const [reFormsPtEvalEnabled] = useFeatureToggleWhenReady(reFormsPtEvalTreatment, 'FACILITY');
  const [reFormsOtEvalEnabled] = useFeatureToggleWhenReady(reFormsPtEvalTreatment, 'FACILITY');
  const [reFormsSlpEvalEnabled] = useFeatureToggleWhenReady(reFormsSlpEvalTreatment, 'FACILITY');
  const [initialized, setInitialized] = useState(false);
  const [iframeRef, setIframeRef] = useState<any | null>(null);
  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    if (!initialized) {
      dispatch(resetUuidAction());
      setInitialized(true);
    }
  }, [initialized, dispatch]);

  const [isFeatureFlag] = useFeatureToggle(prefillIdCPTICDTreatment, 'ENTERPRISE');
  const [isReformDoc, setIsReformDoc] = useState<boolean>(false);

  useEffect(() => {
    if (!document) return;
    setIsReformDoc(document?.formType?.includes('REFORM'));
    dispatch(checkIsReformAction(document?.formType?.includes('REFORM')));
  }, [document]);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  const goBackToEOC = () => {
    dispatch(resetUuidAction());
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
      state: {
        episodeOfCareId: episodeOfCareId,
        getPatientId,
      },
    });
  };

  const handleBackConfirmation = (confirm: boolean) => {
    if (confirm) {
      goBackToEOC();
    }
    setOpenConfirmationModel(false);
  };

  const goBackToEOCConfirm = () => {
    if (isReformDoc) {
      return goBackToEOC();
    }
    setOpenConfirmationModel(true);
    //
  };

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (!isReformDoc) {
        const confirmationMessage =
          'You have unsaved changes. If you leave this page before submitting, your progress will be lost. Are you sure you want to continue?';
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isReformDoc]);
  const [notCallAgain, setNotCallAgain] = useState(false);

  useEffect(() => {
    if (notCallAgain) return;
    if (!document) return;
    let fetchMostRecent = false;

    if (
      reFormsPtEvalEnabled === null ||
      reFormsOtEvalEnabled === null ||
      reFormsSlpEvalEnabled === null
    ) {
      return;
    }

    if (document?.reformId) {
      if (reFormsPtEvalEnabled && document.type === 'PT') {
        fetchMostRecent = true;
      }

      if (reFormsOtEvalEnabled && document.type === 'OT') {
        fetchMostRecent = true;
      }

      if (reFormsSlpEvalEnabled && document.type === 'SLP') {
        fetchMostRecent = true;
      }
    }

    dispatch(
      pullUuidAction(
        {
          uuid: document?.uuid,
          providerId,
          formId: document?.formId,
          episodeOfCareId: episodeOfCareId,
          type: activeTab,
          isForSupervisor: checkSupervisorPermission(
            getSignatureAccess.response?.data?.t1,
            document?.formType
          ),
          entityType: 'EOC',
          documentType: document?.formType,
        },
        {
          fetchMostRecent,
        }
      )
    );
  }, [document, reFormsPtEvalEnabled, reFormsOtEvalEnabled, reFormsSlpEvalEnabled]);

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      if (!isReformDoc) {
        event.preventDefault();
        setOpenConfirmationModel(true);
        window.history.pushState(null, '', window.location.href);
      }
    };

    if (!isReformDoc) {
      window.history.pushState(null, '', window.location.href);
    }
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isReformDoc]);

  useEffect(() => {
    if (!document || !pullUuidResponse.response) return;
    const createEventSource = () => {
      submissionSse.current = new EventSource(
        `${baseApiUrl}${subscribeSubmissionevent}/${pullUuidResponse.response}`
      );

      submissionSse.current.addEventListener('message', (e) => {
        const eventData = JSON.parse(e.data);
        switch (eventData?.data) {
          case '1':
            dispatch(requestForLoaderDocumentation(eventData?.data));
            break;
          case '2':
            dispatch(successForLoaderDocumentation(eventData?.data));
            break;
          case '3':
            dispatch(errorForLoaderDocumentation(eventData?.error));
            break;
          default:
            break;
        }
      });

      submissionSse.current.addEventListener('error', (e: any) => {
        if (e.eventPhase === 2) {
          if (submissionSse.current) {
            submissionSse.current.close();
          }
          createEventSource();
        }
      });

      return () => {
        if (submissionSse.current) {
          submissionSse.current.close();
        }
      };
    };
    createEventSource();
    return () => {
      if (submissionSse.current) {
        submissionSse.current.close();
      }
    };
  }, [document, pullUuidResponse]);

  const [openErrorModal, setOpenErrorModal] = useState(false);
  const closeErrorModal = () => {
    setOpenErrorModal(false);
    dispatch(resetForLoaderDocumentation());
  };

  useEffect(() => {
    if (!isDocLoader.loader && isDocLoader.response === null) return;
    if (isDocLoader.error) {
      setOpenErrorModal(true);
      return;
    }
    if (!isDocLoader.loader) {
      dispatch(resetForLoaderDocumentation());
      goBackToEOC();
    }
  }, [isDocLoader]);

  const prefillDateValue = (prefillData: any, prefillKey: string) => {
    if (prefillData?.includes('null')) {
      return '';
    }
    return `${
      prefillData
        ? `&${prefillKey}[month]=${prefillData?.split('-')[1]}&${prefillKey}[day]=${
            prefillData.split('-')[2].split('T')[0]
          }&${prefillKey}[year]=${prefillData?.split(
            '-'
          )[0]}&${prefillKey}[datetime]=${prefillData?.split('T')[0]}`
        : ''
    }`;
  };

  const getValidstartOfCareDate = () => {
    if (getStartOfCareDate?.length == 0 || !getStartOfCareDate) {
      return prefillDateValue('null', '');
    }
    return prefillDateValue(`${getStartOfCareDate[0]}T00:00:00Z`, 'startOf');
  };

  const getHiddenUuid = (pullUuidResponse: any) => {
    return `${pullUuidResponse?.response?.trim()}X${
      window.location.hostname === 'localhost'
        ? localStorage.getItem('realm')
        : window.location.hostname.split('-')[0]
    }`;
  };

  const getCleanUuid = () => {
    return pullUuidResponse?.response?.trim() || '';
  };

  function checkIsRectification(str: any) {
    if (str?.includes('RECERTIFICATION') || str?.includes('PROGRESS')) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    if (!document) return;
    const destructureUrl = document?.prefillUrl.split('/');
    setPrefillKey(destructureUrl[destructureUrl.length - 1]);
  }, [document]);

  const passPrefillIdToCode = () => {
    if (isFeatureFlag) {
      return `&CodesCPT=${getPrefillKey}&ICD10TreatmentCodes=${getPrefillKey}&ICD10TMedicalCodes=${getPrefillKey}`;
    }
    return '';
  };

  const isReformsEnabled = () => {
    if (!pullUuidResponse?.response || !document.reformId) {
      return false;
    }

    if (reFormsPtEvalEnabled && document.type === 'PT') {
      return true;
    }

    if (reFormsOtEvalEnabled && document.type === 'OT') {
      return true;
    }

    if (reFormsSlpEvalEnabled && document.type === 'SLP') {
      return true;
    }

    return false;
  };

  const checkRecertiOrEval = (formType: string) => {
    if (formType?.includes('RECERTIFICATION') || formType?.includes('EVALUATION')) {
      return true;
    }
    return false;
  };

  const [prefillURl, setPrefillUrl] = useState('');

  useEffect(() => {
    if (notCallAgain) return;
    if (document?.prefillUrl && pullUuidResponse?.response) {
      setPrefillUrl(
        `${document?.prefillUrl}?hiddenUuid=${getHiddenUuid(pullUuidResponse)}${prefillDateValue(
          episodeOfCareData?.startDate,
          'hiddenEocStartDate'
        )}${`&numberHiddenField=${1}`}${getValidstartOfCareDate()}${passPrefillIdToCode()}${
          checkRecertiOrEval(document.formType)
            ? `&payerName=${episodeOfCareData?.payerType}`
            : `&payerName=`
        }`
      );
      setNotCallAgain(true);
    }
  }, [document, episodeOfCareData, pullUuidResponse]);

  return (
    <>
      {isDocLoader.loader && (
        <Grid sx={loaderCSS}>
          <img
            src={loader}
            alt="loader.."
          />
        </Grid>
      )}

      <Grid
        container
        justifyContent={'space-between'}
      >
        <Stack
          gap="1.5rem"
          sx={{ padding: '0 4rem' }}
        >
          <Button
            sx={{
              justifyContent: 'flex-start',
              color: '#111927',
              width: 'max-content',
              padding: '0px',
            }}
            onClick={goBackToEOCConfirm}
            startIcon={
              <SvgIcon>
                <ArrowBackIcon sx={{ color: '#6C737F' }} />
              </SvgIcon>
            }
          >
            <Typography variant="subtitle1">
              Back to Episode Of Care Details -
              {` ${patientData?.lastName ?? ''} ${patientData?.firstName ?? ''}`}
            </Typography>
          </Button>
          <Stack
            flexDirection="row"
            gap="1rem"
            alignItems="center"
          >
            <Typography variant="h5">Edit Document - {document?.documentType}</Typography>
          </Stack>
        </Stack>
        {checkGoalBankToggle && <CopyGoalWidget />}
      </Grid>

      {pullUuidResponse.response && (
        <Box
          sx={{ height: '100%' }}
          p={3}
        >
          {isReformsEnabled() ? (
            <Box style={{ maxHeight: '70vh', overflow: 'auto' }}>
              {initialized && (
                <ReForm
                  uuid={getCleanUuid()}
                  formId={document.reformId}
                />
              )}
            </Box>
          ) : (
            prefillURl && (
              <iframe
                // src={`${prefillURl}?hiddenUuid=${getHiddenUuid()}${prefillDateValue(
                //   episodeOfCareData?.startDate,
                //   'hiddenEocStartDate'
                // )}${`&numberHiddenField=${1}`}${getValidstartOfCareDate()}${passPrefillIdToCode()}`}
                src={prefillURl}
                ref={updateIFrameRef}
                width={'100%'}
                height={'100%'}
                style={{ border: 'none' }}
                title="jotform-prefill"
              />
            )
          )}
        </Box>
      )}

      <BootstrapDialog
        onClose={() => setOpenConfirmationModel(false)}
        aria-labelledby="customized-dialog-title"
        open={openConfirmationModel}
        PaperProps={{ style: { maxWidth: '750px' } }}
      >
        <PageLeaveConfirmModal
          close={() => setOpenConfirmationModel(false)}
          handleSaveBtn={() => handleBackConfirmation(true)}
        />
      </BootstrapDialog>

      <Modal open={openErrorModal}>
        <SucessModal
          close={closeErrorModal}
          isSucess={false}
          title="Edit a Document"
          message={isDocLoader?.response}
        />
      </Modal>
    </>
  );
}

export default EditDocumentPreview;
